import BusinessRegistrationService from '../services/business-registration-service';

export const businessRegistrationPerson = {
  namespaced: true,
  state: {
    person: null,
  },
  actions: {
    newPerson({ commit }, trustmarkPersonId) {
      const template = {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        dateOfBirth: null,
        companiesHouseRegistrationNumber: '',
        trustmarkPersonId: '',
        isResponsiblePerson: false,
        isContractContact: false,
        isBillingContact: false,
        isPWSC: false,
      };
      const empty = JSON.parse(JSON.stringify(template));
      empty.trustmarkPersonId = trustmarkPersonId;
      commit('setPerson', empty);
    },
    createBusinessRegistrationPerson({ commit }, { businessRegistrationNumber, payload }) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationService.createBusinessRegistrationPerson(
        businessRegistrationNumber,
        payload,
      )
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setPerson', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    updateBusinessRegistrationPerson(
      { commit },
      { businessRegistrationNumber, businessRegistrationPersonId, payload },
    ) {
      commit('setIsBusy', true, { root: true });
      return BusinessRegistrationService.updateBusinessRegistrationPerson(
        businessRegistrationNumber,
        businessRegistrationPersonId,
        payload,
      )
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setPerson', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    loadBusinessRegistrationPerson({ commit }, person) {
      commit('setPerson', person);
    },
  },
  mutations: {
    setPerson(state, newPerson) {
      state.person = newPerson;
      if (state.person) {
        state.person.dateOfBirth = state.person.dateOfBirth
          ? new Date(state.person.dateOfBirth)
          : null;
      }
    },
  },
};
